import { useState, useEffect } from "react"

export const ReportModal = ({ isOpen, onClose, match, onConfirm }) => {
  const [score1, setScore1] = useState(match.player1.score)
  const [score2, setScore2] = useState(match.player2.score)

  useEffect(() => {
    if (isOpen) {
      setScore1(match.player1.score)
      setScore2(match.player2.score)
    }
  }, [isOpen, match])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-80 p-6">
        <h2 className="text-xl font-bold mb-4 text-center">Reportar Resultado</h2>

        <div className="flex flex-col gap-3">
          <div className="flex justify-between items-center">
            <span>{match.player1.name}</span>
            <input
              type="number"
              value={score1}
              onChange={(e) => setScore1(parseInt(e.target.value) || 0)}
              className="w-16 border rounded text-center px-2 py-1"
            />
          </div>

          <div className="flex justify-between items-center">
            <span>{match.player2.name}</span>
            <input
              type="number"
              value={score2}
              onChange={(e) => setScore2(parseInt(e.target.value) || 0)}
              className="w-16 border rounded text-center px-2 py-1"
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded"
            onClick={() => onConfirm(score1, score2)}
            disabled={score1 === score2}
          >
            Reportar
          </button>
        </div>
      </div>
    </div>
  )
}
